import { useLocation } from 'react-router';

/**
 * @function useOverrides
 * @returns a higher-order function that takes an `OverrideKey` and a boolean value,
 *   which returns either the value stored at the `OverrideKey` or, if there is none, the passed boolean.
 *
 * This is used in QA/development/testing to bypass certain eligibility checks.
 */
export const useOverrides = <OverrideKey extends string>(
	queryKey: string,
): Partial<Record<OverrideKey, boolean>> => {
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const value = queryParams.get(queryKey);
	const overrides: Partial<Record<OverrideKey, boolean>> = {};
	if (value) {
		value.split(',').forEach((key) => {
			overrides[key.trim() as OverrideKey] = false;
		});
	}
	return overrides;
};
